import { ExistingSystemType } from 'data/types';
import { TonnageSeedRange } from 'features/ui/tonnage-filter-seed-types';
import { isPtacExistingSystem } from 'utils/equipment-preferences-complete';
import { resolveTonnageSeed, TonnageRecord } from 'utils/tonnage-logic';

// The Choose Systems / compatibility-check size seed for ONE system: the
// shared tonnage resolver for ducted systems, and never a seed for a PTAC
// system — its size is a BTU class, not a point on the tonnage scale, so a
// calc-derived tonnage range would filter out the very units it wants.
export function resolveSystemTonnageSeed(args: {
  system: Pick<ExistingSystemType, 'type' | 'components'> | null | undefined;
  record: TonnageRecord | null | undefined;
  coolingBtu: number | null | undefined;
}): TonnageSeedRange | null {
  if (args.system && isPtacExistingSystem(args.system)) return null;
  return resolveTonnageSeed({
    record: args.record,
    components: args.system?.components,
    coolingBtu: args.coolingBtu
  });
}
